import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
    customerId: string;
    onSuccess: () => void;
}

export const useInvoicePaymentsQuery = ({ customerId, onSuccess }: IProps) => useQuery(
  'InvoicePaymentsQuery',
  async () => {
    const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/paymentOptions`);
    return data;
  },
  {
    enabled: true,
    retry: 2,
    refetchOnWindowFocus: false,
    onSuccess: () => {
      onSuccess();
    },
  },
);
